/*
 *
 * Copyright (c) Vaisala Oyj. All rights reserved.
 *
 */

import * as React from 'react';
import { Table, TableBody, TableCell, TableHead, TableRow, TableCellType, Icon, Size, Spinner } from '@vaisala/rockhopper-components';
import { VaiIcon} from '@vaisala/rockhopper-design-tokens';
import { NCInfo } from '../state/project/@types';


interface Props {
    date : boolean;
    nc_info : {[key : string] : NCInfo[]};
    fetchingFiles: boolean;
    selectedMode: String;
}

export const NCFilesInfoList : React.FC<Props> = (props) => {
    
    const {
        nc_info,
        date,
        fetchingFiles,
        selectedMode,
    } = props

    const [ncInfoFiles, setNcInfoFiles] = React.useState(nc_info);

    const [expandFilesIndex, setExpandFilesIndex] = React.useState(["", -1]);
     
    React.useEffect(() => {
    
        const newNcInfoFiles : {[key : string] : NCInfo[]} = Object.fromEntries(Object.entries(nc_info)) ;


        Object.keys(newNcInfoFiles).map((key) => {

            newNcInfoFiles[key] = nc_info[key].reduce((result, item, index) => {
                
                if (expandFilesIndex[0] === key && expandFilesIndex[1] === index){
                    let filesArray : NCInfo[] ;

                    if (item.files){
                        filesArray = item.files.map((file) => ({
                        scan_id: item.scan_id,
                        number_of_files: -1,
                        files: [file]
                        }));
                    } else {
                        filesArray = [];
                    }

                    return result.concat([item, ...filesArray]);   
                } else {                 
                    return result.concat([item]);
                }

            }, [] as NCInfo[])

            return true;
        });

        setNcInfoFiles({...newNcInfoFiles});

    }, [expandFilesIndex, nc_info])



    const handleExpandFiles = (key : string, index : number) => {
        if (expandFilesIndex[0] === key && expandFilesIndex[1] === index){
            setExpandFilesIndex(["", -1]);
        } else {
            setExpandFilesIndex([key, index]);
        }
    }

    return (
        <Table useHover condensed fixedHeader isFullWidth>
            <TableHead>
                <TableRow>
                    <TableCell width={date?"65%":"70%"}>
                        Lidar ID
                    </TableCell>
                    <TableCell type={TableCellType.Numeric} width="15%">
                        Scan ID
                    </TableCell>
                    <TableCell type={TableCellType.Numeric} width="15%">
                        Nb files
                    </TableCell>
                    {
                    date?
                    <TableCell type={TableCellType.Centered} width="5%">
                        Files
                    </TableCell>
                    : null
                    }
                </TableRow>
            </TableHead>
            <TableBody>
            {
            Object.entries(ncInfoFiles).map(([key, nc_list]) => 
                    nc_list.map((info, index) => {
                        return (
                            (date && expandFilesIndex[1] !== -1 ) ? 
                            <TableRow>
                                <TableCell width={date?"65%":"70%"}>
                                    {info.number_of_files === -1 && info.files ? info.files[0] : key}
                                </TableCell>
                                <TableCell type={TableCellType.Numeric} width="15%">
                                    {info.number_of_files === -1 ? " " : info.scan_id}
                                </TableCell>
                                <TableCell type={TableCellType.Numeric} width="15%">
                                    {info.number_of_files === -1 ? " " : info.number_of_files}
                                </TableCell>
                                {
                                    info.number_of_files === -1 ?
                                    <TableCell width="5%">
                                        {"  "}
                                    </TableCell>
                                    : 
                                    <TableCell
                                        type={TableCellType.Centered}
                                        width="5%"
                                        onClick={() => handleExpandFiles(key, index)}
                                    >
                                        <Icon size={Size.XS} name={VaiIcon.ArrowUpAndDown} />

                                    </TableCell>
                                }
                            </TableRow> :
                            <TableRow>
                            <TableCell width={date ? "65%" : "70%"}>
                                {index === 0 ? key : " "}
                            </TableCell>
                            <TableCell type={TableCellType.Numeric} width="15%">
                                {info.scan_id}
                            </TableCell>
                            <TableCell type={TableCellType.Numeric} width="15%">
                                {info.number_of_files}
                            </TableCell>
                        
                            {
                                selectedMode === "LEFT" ? (
                                    null
                                ) : selectedMode === "RIGHT" && date && fetchingFiles ? (
                                    <TableCell
                                        type={TableCellType.Centered}
                                        width="5%"
                                        onClick={() => handleExpandFiles(key, index)}
                                    >
                                        <Spinner />
                                    </TableCell>
                                ) : (
                                    <TableCell
                                        type={TableCellType.Centered}
                                        width="5%"
                                        onClick={() => handleExpandFiles(key, index)}
                                    >
                                        <Icon size={Size.XS} name={VaiIcon.ArrowUpAndDown} />
                                    </TableCell>
                                )
                            }
                        </TableRow>
                        
                        );
                    })
                )
            }
        </TableBody>
        </Table>
    );
};